"use client";
import { useState, useEffect } from 'react';

interface UseScrollPositionOptions {
  threshold?: number;
  addBottomPadding?: boolean;
}

export function useScrollPosition({ 
  threshold = 100, 
  addBottomPadding = false 
}: UseScrollPositionOptions = {}) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const shouldBeVisible = scrollY > threshold;
      setIsVisible(shouldBeVisible);
      
      // Add bottom padding to body when bar is visible
      if (addBottomPadding) {
        if (shouldBeVisible) {
          document.body.style.paddingBottom = '80px';
        } else {
          document.body.style.paddingBottom = '0px';
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    // Cleanup on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (addBottomPadding) {
        document.body.style.paddingBottom = '0px';
      }
    };
  }, [threshold, addBottomPadding]);

  return isVisible;
}
